export default __webpack_public_path__ + "static/Crisp-204fcc54f02a8a0db49da3f0c37ea6ad.png";